export default function assessmentUniqueNameDirective(
  $q,
  praDataService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const assessmentId = attributes.assessmentId || 0;
    ngModel.$asyncValidators.praAssessmentUniqueName = (modelValue) => {
      const defer = $q.defer();
      praDataService.checkAssessmentExists(
        modelValue,
        assessmentId
      ).then(() => {
        // if (
        //   data
        //   && data.data.result === false
        // ) {
        defer.resolve();
        // } else {
        //   defer.reject();
        // }
      }).catch(defer.reject);
      return defer.promise;
    };
  }
}

export const name = 'praAssessmentUniqueName';

assessmentUniqueNameDirective.$inject = [
  '$q',
  'praDataService'
];
